import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
  Button,
  CircularProgress,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { common_axios } from "../../../../App";
import { ToastContainer } from "react-toastify";
import Loader from "../../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FormControl from "@mui/material/FormControl";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EditIcon from "@mui/icons-material/Edit";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { dateFormatter } from "../../../../helper/helper";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Transfer } from "antd";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import { InputAdornment, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
// import { Select } from "@material-ui/core";
import Select from "@mui/material/Select";
import * as yup from "yup";
import TransferListTest from "./TransferListTest";
import { useCallback } from "react";
import { setRelodState } from "../../../../redux/actions/reloadAction";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import ProgressLoader from "../../Reports/DeliveryReports/ProgressLoader";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

function LinearProgressWithLabel(props) {
  // console.log({ props });

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "90%" }} className="mx-auto">
        <LinearProgress
          //   color="green"className="mt-1"
          className="mt-1"
          sx={{
            "& .MuiLinearProgress-bar1Determinate": {
              backgroundColor: props.colorr,
            },
          }}
          variant="determinate"
          {...props}
        />
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
  color: PropTypes.number.isRequired,
};
const PhoneBookList = () => {
  const customId1 = "custom-id-yess";
  const [ContactArray, SetContactArray] = useState([]);
  const [Namedata, setNamedata] = useState("");
  const [data, setData] = useState([]);
  // console.log("data--", Namedata);
  const [Search, setSearch] = useState(undefined);
  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [TableStatusView, setTableStatusView] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [viewDetail, setViewDetail] = useState([]);
  const [viewPageModal, setViewPageModal] = useState([]);
  const [data2, setData2] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [arrayvalue, setArrayValue] = useState("default");
  const [age, setAge] = useState(undefined);
  const [top100Films, setTop100Films] = useState([]);
  const [phoneBookState, setPhoneBookState] = React.useState([]);
  const [searchPhoneBookState, setSearchPhoneBookState] = useState("");
  const [viewEnterPhonebook, setViewEnterPhoneBook] = useState([]);
  const [data1, setData1] = useState([]);
  const [mockData, setMockdata] = useState([]);
  const [rightData, setRightData] = useState([]);
  const [transferListData, setTransferListData] = useState([]);
  // console.log("mockdata--", mockData);
  const [targetKeys, setTargetKeys] = useState([]);
  const [targetId, setTargetId] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);

  //  console.log("766", viewDetail);
  function handleChange1(event) {
    setArrayValue(event.target.value);
  }

  const dispatch = useDispatch();
  const handleChange2 = (e) => {
    setSearchPhoneBookState(e.target.value);
  };
  useEffect(() => {
    let temp_arr = [];
    for (let i = 0; i < top100Films?.length; i++) {
      temp_arr.push(top100Films[i]);
    }
    setViewEnterPhoneBook(temp_arr);
  }, [top100Films]);

  const handleChangee = (e) => {
    setAge(e.target.value);
    // setDownloadDisable(false);
  };

  function handleChangesearch(event) {
    setSearch(event.target.value);
  }

  const initialValues = {
    phoneBookName: "",
    // emailId: "",
    // description:""
  };
  const validationSchema = yup.object({
    phoneBookName: yup
      .string()
      .min(3, "Please enter atleast 3 characters in phoneBookName")
      .max(90, "No more longer to 90 charcaters")
      .nullable(),
  });
  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    // validationSchema: validationSchema,

    onSubmit: (values) => {
      // ContactPost(values);
      // alert("kkki")
      FilterBtn(values);
    },
  });
  // ...............................Serach Api................................................//
  async function SearchName(values) {
    // alert("3333")
    try {
      // setHideSkeleton(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/user-contacts/list/by/contact-name?contactName=${Search}`
      );
      if (res.data.statusdescription.statusCode == 200) {
        // setHideSkeleton(false);
        // setData1(res.data.listOfUserContacts);
      } else {
        // setOpen(false);
        // setHideSkeleton(false);
        // toast.error(res.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setOpen(false);
      // setHideSkeleton(false);
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  // useEffect(() => {
  //   if (Search != undefined) {
  //     SearchName();
  //   }
  // }, [Search]);
  // ............................................................................//
  async function ContactGet(values) {
    setData([]);
    try {
      setOpen(true);

      setHideSkeleton(true);

      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-books/v1/list?pageNo=${TableStatus.pageNo}&pageSize=${TableStatus.pageSize}`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setOpen(false);
        setHideSkeleton(false);
        setData(res.data.playsms.content);
        setData2(res.data.playsms);
        // await setTotalPage(res.data.playsms.totalPages);
        // await settotalPageCount(res.data.playsms.number);
      } else {
        setHideSkeleton(false);

        setOpen(false);
        // toast.error(res.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      setOpen(false);
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  const x = useSelector((state) => state.relodReducer.relodState);
  // console.log("x--", x);
  useEffect(() => {
    ContactGet();
  }, [x, TableStatus.pageSize, TableStatus.pageNo]);

  // // .........................Refresh Btn Api..................................//

  async function RefreshBtn(values) {
    setData([]);
    try {
      setOpen(true);

      setHideSkeleton(true);

      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-books/v1/list?pageNo=${TableStatus.pageNo}&pageSize=${TableStatus.pageSize}`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setOpen(false);
        setHideSkeleton(false);
        setData(res.data.playsms.content);
        setData2(res.data.playsms);
        // await setTotalPage(res.data.playsms.totalPages);
        // await settotalPageCount(res.data.playsms.number);
      } else {
        setHideSkeleton(false);

        setOpen(false);
        // toast.error(res.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      setOpen(false);
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // // .....................................................................................................//

  async function LoaderApi(values) {
    try {
      // setOpen(true);

      setHideSkeleton(true);

      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-books/v1/list?pageNo=${TableStatus.pageNo}&pageSize=${TableStatus.pageSize}`
      );
      if (res.data.statusdescription.statusCode == 200) {
        // setOpen(false);
        setHideSkeleton(false);
        setDownloadLoader(false);

        setData(res.data.playsms.content);
        setData2(res.data.playsms);
        // await setTotalPage(res.data.playsms.totalPages);
        // await settotalPageCount(res.data.playsms.number);
      } else {
        setHideSkeleton(false);

        setOpen(false);
        // toast.error(res.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      setOpen(false);
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // ...............................Download API On Download Button And Redirect................................................//

  async function DownloadButtonApi(values) {
    setDownloadLoader(true);

    try {
      // setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/export/phone-book/excel`,
        {
          downloadReportRequest: {
            phoneBookId: downloadModelOpen?.id,
            reportType: "Phonebook",
            username: localStorage.getItem("Username"),
            phoneBookName: downloadModelOpen?.phonebookName,
          },
        }
      );
      if (result.data.statusdescription.statusCode == 200) {
        // DownloadTabApi()
        // setOpen(false);
        LoaderApi();
        // const butt = document.getElementById("Download-tab");
        // butt.click();
      } else {
        // setData([])

        setOpen(false);
        setDownloadLoader(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      setDownloadLoader(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }
  // ............................................................................................//
  // ..........................................................................................................................//

  const downloadFile = async (cell) => {
    try {
      const response = await common_axios.get(
        `${cell?.row?.original.dwonloadReport?.downloadUrl}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            // UserId:`${localStorage.getItem('UserId')}`,
            // Source: "web",
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };
  // ................................................................................................................

  // ...............................DownloadTab API Redirect................................................//
  // const [downloadData, setDownloadData] = useState([]);

  // async function DownloadTabApi(values) {
  //   setData([]);
  //   try {
  //     setOpen(true);
  //     const result = await common_axios.post(
  //       `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
  //       // {
  //       //   pageNo: Status?.pageNo,
  //       //   pageSize: Status?.pageSize,
  //       // }

  //       {
  //         downloadReportRequest: {
  //             reportType:"phonebook",
  //             pageNo: TableStatus?.pageNo,
  //             pageSize: TableStatus?.pageSize,
  //         }
  //     }
  //     );
  //     // console.log("------resultssss", result);
  //     if (result.data.statusdescription.statusCode == 200) {
  //       setOpen(false);
  //       // setData1(result.data?.downloadReport);
  //       setDownloadData(result.data?.downloadReport);
  //       // setData(result.data?.downloadReport?.content);
  //     } else {
  //       setOpen(false);
  //       setData([]);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: result.data.statusdescription.statusMessage,
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   } catch (error) {
  //     setOpen(false);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Please Check Your Network",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   }
  //   // console.log("response..", res);
  // }

  // useEffect(() => {
  //   // if (Status?.approveType == "Download") {
  //   DownloadTabApi();
  //   // }
  // }, []);

  // .................................KEYWORD DELETE API...................................//
  const [open, setOpen] = useState(false);
  const rejectUserApi = async (selectedUserDetail) => {
    // console.log("selectedUserDetail-----==", selectedUserDetail);
    try {
      setOpen(true);
      const deleteResponse = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/delete/phone-book/by/id?phoneBookId=${selectedUserDetail.id}`
      );
      if (deleteResponse.data.statusdescription.statusCode == 200) {
        setOpen(false);
        // FilterGet();
        ContactGet();
        // toast.success("Phonebook deleted successfully!!", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Phonebook deleted successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // toast.error(deleteResponse.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: deleteResponse.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };

  // .................................KEYWORD Update API...................................//
  const UpdateUserApi = async (selectedUserEditDetails) => {
    // console.log("selectedUserEditDetails-----==", selectedUserEditDetails);
    try {
      setOpen(true);
      let updateData = [];
      let deleteData = [];

      if (transferListData?.rightsideAddedData) {
        Object.keys(transferListData?.rightsideAddedData)?.map((dd) => {
          transferListData?.rightsideAddedData?.[dd]?.map((dd1) => {
            // console.log({ dd1 });
            updateData.push(dd1.id);
          });
        });
      }

      if (transferListData?.leftsideAddedData) {
        Object.keys(transferListData?.leftsideAddedData)?.map((dd) => {
          transferListData?.leftsideAddedData?.[dd]?.map((dd1) => {
            // console.log({ dd1 });
            deleteData.push(dd1.id);
          });
        });
      }

      // console.log({ updateData, deleteData });
      const UpdateResponse = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/phone-book/update`,
        {
          phoneBookId: selectedUserEditDetails.id,
          phoneBookName: selectedUserEditDetails.phonebookName,
          phonebookDescription: selectedUserEditDetails.phonebookDescription,
          modifiedBy: selectedUserEditDetails.createdBy,
          updatePhoneBookId: updateData?.length > 0 ? updateData : [],
          deletePhoneBookId: deleteData?.length > 0 ? deleteData : [],
        }
      );
      // console.log("UpdateResponse--------", UpdateResponse);
      if (UpdateResponse.data.statusdescription.statusCode == 200) {
        setOpen(false);
        // FilterGet();
        ContactGet();

        setRightData(null);
        const variable = {
          phonebookName: 1,
          // phonebookDescription: values.phonebookDescription,
          phonebookDescription: 1,
          userContactsReq: 1,
        };
        dispatch(setRelodState(variable));

        // toast.success("Phonebook updated successfully!!", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Phonebook Added successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // toast.error(UpdateResponse.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: UpdateResponse.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log({ error });
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };
  // console.log("data table------", data);
  // ............................Table.......................//
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectedUserEditDetails, setSelectedUserEditDetails] =
    useState(undefined);
  // console.log("select--", selectedUserEditDetails);
  const [downloadModelOpen, setDownloadModel] = useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const modelButtonEdit = useRef(null);

  const modelButtonDownload = useRef(null);
  const DownloadAction = async (cell) => {
    setDownloadModel(cell.row.original);
    await modelButtonDownload.current.click();
  };
  //  console.log("model--", downloadModelOpen);

  const approveUserModal = async (cell) => {
    // console.log("cell--", cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await setTop100Films(cell?.row?.original?.userContactList);
    // await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };

  const EditUserModal = async (cell) => {
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2000);

    await setSelectedUserEditDetails(cell.row.original);
    if (cell.row.original?.id) setRightData(cell.row.original);
    await modelButtonEdit.current.click();
  };

  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              ),
            },

            {
              Header: "Phonebook Name",
              accessor: "phonebookName", // accessor is the "key" in the data
            },
            {
              Header: "Phonebook Description",
              accessor: "phonebookDescription",
            },
            {
              Header: "Created By",
              accessor: "createdBy",
            },
            {
              Header: "Created On",
              accessor: "createdOn",
            },
            {
              Header: "Contact Count",
              accessor: "contactCount",
            },
            {
              Header: "Action",
              accessor: "action",
              Cell: (cell) => (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="dropdown">
                    <button
                      className="btn color_1 dropdown-toggle px-2"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons opacity-10 size">person</i>
                      {/* <DeleteIcon /> */}
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        onClick={() => {
                          // console.log(cell);
                        }}
                      >
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            rejectUserModal(cell);
                          }}
                        >
                          <DeleteIcon className="color_red_UP me-2" />
                          Delete
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          <RemoveRedEyeIcon className="color_blue2_UP me-2" />
                          View Details
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            EditUserModal(cell);
                          }}
                        >
                          <EditIcon className="color_Green_UP me-2" />
                          Edit Details
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              ),
              disableFilters: true,
            },

            {
              Header: "Download",

              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.dwonloadReport?.file_status ==
                      false ||
                    (downloadModelOpen?.id === cell?.row?.original?.id &&
                      downloadLoader == true) ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : cell?.row?.original?.dwonloadReport?.file_status ==
                      true ? (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="">
                        <button
                          type="button"
                          className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                          id="btn_Update"
                          style={{ width: "auto" }}
                          onClick={() => {
                            DownloadAction(cell);
                          }}
                          // disabled={DownloadDisable}
                        >
                          {/* Download Request */}
                          <DownloadingSharpIcon />
                        </button>
                      </div>
                    )}
                  </>
                );
              },
            },

            //  {
            //         Header: "Download Request",
            //         Footer: "Download",

            //         Cell: (cell) => {
            //           return (
            //             <>
            //               {cell?.row?.original.dwonloadReport?.file_status == false ? (
            //                 <>
            //             <p style={{ fontSize: "12px" }} className="process_txt">In Process</p>
            //             <ProgressLoader />
            //           </>
            //               ) : cell?.row?.original.dwonloadReport?.file_status == true ? (
            //                 <>
            //             <p style={{ fontSize: "12px" }} className="text-center fw-bold">Completed</p>
            //             <LinearProgressWithLabel
            //               colorr={
            //                 cell?.row?.original.dwonloadReport?.file_status == true
            //                   && "green"
            //                   // : "blue"
            //               } style={{width: "8rem"}} className="mx-auto"
            //             />
            //           </>
            //               ): (
            //                 <div className="">
            //            <button
            //                                 type="button"
            //                                 className="btn btn_wt_8 btn_update mx-auto m-0 radius d-flex align-items-center" id="btn_Update"
            //                                 style={{ width: "auto" }}
            //                                 onClick={() => {
            //                DownloadAction(cell);
            //               }}
            //                               >
            //                                 Download Request
            //                               </button>
            //            </div>
            //               )}
            //             </>
            //           );
            //         },
            //       },
            //       {
            //         Header: "Download",
            //         Footer: "Download",

            //         Cell: (cell) => {
            //           return (
            //             <>
            //               {cell?.row?.original.dwonloadReport?.file_status == false ? (
            //                 <></>
            //               ) : cell?.row?.original.dwonloadReport?.file_status == true ? (
            //                 <>
            //                   <div className="">
            //                     <button
            //                       className="btn color_1 px-2"
            //                       type="button"
            //                       id=""
            //                       data-bs-toggle=""
            //                       aria-expanded="false"
            //                       onClick={() => {
            //                         downloadFile(cell);
            //                       }}
            //                     >
            //                       <FileDownloadIcon />
            //                     </button>
            //                   </div>
            //                 </>
            //               ) : (<><span className="text-center">NA</span></>)

            //               }
            //             </>
            //           );
            //         },
            //       },
            // {
            //   Header: "Action",
            //   accessor: "action",
            //   Cell: (cell) => (
            //     <div className="dropdown">
            //       <button
            //         className="btn color_1 dropdown-toggle"
            //         type="button"
            //         id="dropdownMenuButton1"
            //         data-bs-toggle="dropdown"
            //         aria-expanded="false"
            //       >
            //         <i className="material-icons opacity-10 size">person</i>
            //         {/* <DeleteIcon /> */}
            //       </button>
            //       <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            //         <li
            //           onClick={() => {
            //             console.log(cell);
            //           }}
            //         >
            //           <a
            //             className="dropdown-item"
            //             onClick={() => {
            //               rejectUserModal(cell);
            //             }}
            //           >
            //             <DeleteIcon />
            //             Delete
            //           </a>
            //         </li>
            //         <li>
            //           <a
            //             className="dropdown-item"
            //             onClick={() => {
            //               approveUserModal(cell);
            //             }}
            //           >
            //             <RemoveRedEyeIcon />
            //             View Details
            //           </a>
            //         </li>
            //         <li>
            //           <a
            //             className="dropdown-item"
            //             onClick={() => {
            //               EditUserModal(cell);
            //             }}
            //           >
            //             <EditIcon />
            //             Edit Details
            //           </a>
            //         </li>
            //       </ul>
            //     </div>
            //   ),
            //   disableFilters: true,
            // },
            // {
            //   Header: "Download",
            //   Footer: "Download",
            //   // accessor: "downloadUrl",
            //   Cell: (cell) => (
            //     <div className="">
            //       {/* <a  href={cell.row.original.downloadUrl} > */}
            //       <button
            //         className="btn color_1 "
            //         type="button"
            //         id=""
            //         data-bs-toggle=""
            //         aria-expanded="false"
            //         onClick={() => {
            //           DownloadAction(cell);
            //         }}
            //       >
            //         <FileDownloadIcon />
            //       </button>
            //       {/* </a> */}
            //     </div>
            //   ),
            // },
          ]
        : [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              ),
            },

            {
              Header: "Phonebook Name",
              accessor: "phonebookName", // accessor is the "key" in the data
            },
            {
              Header: "Phonebook Description",
              accessor: "phonebookDescription",
            },

            {
              Header: "Created On",
              accessor: "createdOn",
            },
            {
              Header: "Contact Count",
              accessor: "contactCount",
            },
            {
              Header: "Action",
              accessor: "action",
              Cell: (cell) => (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="dropdown">
                    <button
                      className="btn color_1 dropdown-toggle px-2"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons opacity-10 size">person</i>
                      {/* <DeleteIcon /> */}
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        onClick={() => {
                          // console.log(cell);
                        }}
                      >
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            rejectUserModal(cell);
                          }}
                        >
                          <DeleteIcon className="color_red_UP me-2" />
                          Delete
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          <RemoveRedEyeIcon className="color_blue2_UP me-2" />
                          View Details
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            EditUserModal(cell);
                          }}
                        >
                          <EditIcon className="color_Green_UP me-2" />
                          Edit Details
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              ),
              disableFilters: true,
            },

            {
              Header: "Download Request",
              Footer: "Download",
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original.dwonloadReport?.file_status ==
                    false ? (
                      <>
                        <p style={{ fontSize: "12px" }} className="process_txt">
                          In Process
                        </p>
                        <ProgressLoader />
                      </>
                    ) : cell?.row?.original.dwonloadReport?.file_status ==
                      true ? (
                      <>
                        <p
                          style={{ fontSize: "12px" }}
                          className="text-center fw-bold"
                        >
                          Completed
                        </p>
                        <LinearProgressWithLabel
                          colorr={
                            cell?.row?.original.dwonloadReport?.file_status ==
                              true && "green"
                            // : "blue"
                          }
                          style={{ width: "8rem" }}
                          className="mx-auto"
                        />
                      </>
                    ) : (
                      <div className="">
                        <button
                          type="button"
                          className="btn btn_wt_8 btn_update mx-auto m-0 radius d-flex align-items-center"
                          id="btn_Update"
                          style={{ width: "auto" }}
                          onClick={() => {
                            DownloadAction(cell);
                          }}
                          // disabled={DownloadDisable}
                        >
                          Download Request
                        </button>
                      </div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Download",
              Footer: "Download",
              // accessor: "downloadUrl",

              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original.dwonloadReport?.file_status ==
                    false ? (
                      <></>
                    ) : cell?.row?.original.dwonloadReport?.file_status ==
                      true ? (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <span className="text-center">NA</span>
                      </>
                    )}
                  </>
                );
              },
            },
          ],
    [TableStatus, downloadLoader]
  );
  // console.log(Status, "lalalaallalas");
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  // ----------------------Contact get api------------------------
  async function ViewFullTransfer(values) {
    try {
      // setHideSkeleton(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/user-contacts/v1/list`
        // "http://192.168.167.66:4900/user/user-contacts/v1/list"
      );

      if (res.data.statusdescription.statusCode == 200) {
        // setHideSkeleton(false);
        // setData1(res.data.listOfUserContacts);
        // setData1(res.data.listOfUserContacts);
        // toast.success("Added successfully!!", {
        //   theme: "colored",
        // });
      } else {
        // setOpen(false);
        // setHideSkeleton(false);
        // toast.error(res.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setHideSkeleton(false);

      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // useEffect(() => {
  //   ViewFullTransfer();
  // }, []);

  // -------------------------Contact get api-----------------------
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const RemovePhoneBook = () => {
    setViewEnterPhoneBook([]);
  };

  // ------------------------Edit transfer list-------------------------

  // useEffect(() => {
  //   // getMock();
  //   const targetKeys = [];
  //   const mockData = [];
  //   const targetId = [];
  //   for (let i = 0; i < data1?.length; i++) {
  //     const data2 = {
  //       // key: i.toString(),
  //       key: `${data1[i].id}`,
  //       id: `${data1[i].id}`,
  //       // title: `content${i + 1}`,
  //       title: `${data1[i].contactName}`,

  //       chosen: "",
  //     };
  //     if (data2.id) {
  //       targetId.push(data2.id);
  //       targetKeys.push(data2.key);
  //       // SelectedContactName.push(data.title)
  //     }
  //     mockData.push(data2);
  //   }
  //   setMockdata(mockData);
  // }, [data1]);
  let z = [];
  let y = [];
  const handleChange9 = (targetKeys) => {
    // console.log("target--", targetKeys);
    setTargetKeys(targetKeys);
    for (let i = 0; i < mockData.length; i++) {
      for (let j = 0; j < targetKeys.length; j++) {
        if (targetKeys[j] == mockData[i].id) {
          // x.push(mockData[i].id);
          z.push({ id: mockData[i].id });
          y.push({
            name: mockData[i].title,
          });
        }
      }
    }
    setTargetId(z);
    // setSelectedContactName(y);
  };
  useEffect(async () => {
    let a = [];

    if (selectedUserEditDetails != undefined) {
      for (
        let i = 0;
        i < selectedUserEditDetails?.userContactList.length;
        i++
      ) {
        for (let j = 0; j < mockData.length; j++) {
          if (
            mockData[j].id == selectedUserEditDetails?.userContactList[i].id
          ) {
            a.push(mockData[j].id);
          }
        }
      }

      setTargetKeys(a);
    }
  }, [selectedUserEditDetails]);
  // console.log("selected--", selectedUserEditDetails);

  useEffect(() => {
    let y = [];
    let z = [];
    for (let i = 0; i < mockData.length; i++) {
      for (let j = 0; j < targetKeys.length; j++) {
        if (targetKeys[j] == mockData[i].id) {
          // x.push(mockData[i].id);
          z.push({ id: mockData[i].id });
          y.push({
            name: mockData[i].title,
          });
        }
      }
    }
    setTargetId(z);
  }, [targetKeys]);

  // ------------------------End transfer list--------------------------

  const handleChange3 = (e) => {
    setNamedata(e.target.value);
  };

  // .....................................FilterButton.................................//
  async function FilterBtn(values) {
    // alert("kkkk")
    try {
      setOpen(true);
      const response = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/phoneBook`,
        {
          phoneBookName: values.phoneBookName,
          pagination: {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
          },
        }
      );
      // console.log("deleteResponse--------", deleteResponse);
      if (response.data.statusdescription.statusCode == 200) {
        setOpen(false);
        setData(response.data.playsms.content);

        // toast.success(response.data.statusdescription.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: response.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // toast.error(response.data.statusdescription.statusDescription, {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // toast.error("Please Check Your Network", {
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  }

  const handleData = useCallback(
    (data) => {
      setTransferListData(data);
    },
    [transferListData]
  );

  // .............................................View Details Pagination API..................................................//

  async function ViewTablePagination() {
    try {
      setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get/user-contacts/in/phonebook`,

        {
          pageNo: TableStatusView?.pageNo,
          pageSize: TableStatusView?.pageSize,
          phoneBookId: selectedUserDetailApprove.id,
        }
      );
      if (result.data.statusdescription.statusCode == 200) {
        setOpen(false);

        setViewDetail(result?.data?.userContact?.content);
        setViewPageModal(result?.data?.userContact);
        await modelButtonApprove.current.click();
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusdescription.statusDescription,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }

  useEffect(() => {
    if (selectedUserDetailApprove != undefined) {
      ViewTablePagination();
    }
  }, [
    selectedUserDetailApprove,
    // TableStatusView?.pageNo,
    // TableStatusView?.pageSize,
  ]);

  async function ViewTablePagination1() {
    try {
      setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get/user-contacts/in/phonebook`,

        {
          pageNo: TableStatusView?.pageNo,
          pageSize: TableStatusView?.pageSize,
          phoneBookId: selectedUserDetailApprove.id,
        }
      );
      if (result.data.statusdescription.statusCode == 200) {
        setOpen(false);

        setViewDetail(result?.data?.userContact?.content);
        setViewPageModal(result?.data?.userContact);
        // await modelButtonApprove.current.click();
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusdescription.statusDescription,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }

  useEffect(() => {
    if (TableStatusView?.hideShow != false) {
      ViewTablePagination1();
    }
  }, [TableStatusView?.pageNo, TableStatusView?.pageSize]);

  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        {data?.length > 0 ? (
          <>
            {" "}
            <div className="card-body">
              <div className="card shadow-none border bg_blue mt-4">
                <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                  {/* Add Number */}
                  View PhoneBook
                </span>
                <div className="card-body text-lg-start text-center">
                  <section class="cmp">
                    <div class="container-fluid">
                      <>
                        <div class="row">
                          <div className="d-flex justify-content-between my-auto">
                            <div className="">
                              <div className="d-flex">
                                <div className="my-auto">
                                  <select
                                    value={TableStatus.pageSize}
                                    className="dropdown p-2"
                                    onChange={(e) => {
                                      setPageSize(Number(e.target.value));
                                      setTableStatus({
                                        ...TableStatus,
                                        pageSize: e.target.value,
                                        pageNo: 0,
                                      });
                                    }}
                                  >
                                    {[10, 25, 50].map((value, i) => {
                                      return (
                                        <option
                                          className="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton1"
                                          value={value}
                                          key={value}
                                        >
                                          Show {value}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div class="my-auto ms-3">
                                  <div
                                    className="text-end"
                                    style={{ flexGrow: "1" }}
                                  >
                                    <IconButton
                                      variant="text"
                                      size="small"
                                      sx={{
                                        color: "#7B809A",
                                      }}
                                      onClick={(event) => {
                                        setTableStatus({
                                          ...TableStatus,
                                          hideShow: !TableStatus.hideShow,
                                        });
                                        setNamedata("");
                                      }}
                                    >
                                      {TableStatus.hideShow ? (
                                        <CancelIcon />
                                      ) : (
                                        <SearchIcon />
                                      )}
                                    </IconButton>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex flex-wrap justify-content-between ">
                              <form
                                onSubmit={formik.handleSubmit}
                                role="form"
                                className="text-start"
                              >
                                <div
                                  className="d-flex"
                                  style={{
                                    minHeight: "4rem",
                                    maxHeight: "4rem",
                                  }}
                                >
                                  <div className="">
                                    {TableStatus.hideShow && (
                                      <>
                                        {hideSkeleton == true ? (
                                          <>
                                            <Box sx={{ width: 230 }}>
                                              <Skeleton />
                                              <Skeleton animation="wave" />
                                              {/* <Skeleton animation={false} /> */}
                                            </Box>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="d-flex me-3"
                                              style={{ width: "200px" }}
                                            >
                                              <FormControl
                                                required
                                                fullWidth
                                                size="small"
                                              >
                                                <InputLabel id="demo-simple-select-autowidth-label">
                                                  Search Category
                                                </InputLabel>
                                                <Select
                                                  labelId="demo-simple-select-autowidth-label"
                                                  id="demo-simple-select-autowidth"
                                                  value={Namedata}
                                                  onChange={handleChange3}
                                                  autowidth
                                                  label=" Search Category"
                                                  // required
                                                >
                                                  {/* <MenuItem selected value={0}>
                                    All
                                  </MenuItem> */}

                                                  <MenuItem value={0}>
                                                    PhoneBookList{" "}
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                  {Namedata === 0 && (
                                    <>
                                      <div className="d-flex">
                                        <TextField
                                          className=" w-100"
                                          style={{
                                            borderRadius: "4px",
                                          }}
                                          type="text"
                                          label="Phonebook search"
                                          name="phoneBookName"
                                          variant="outlined"
                                          size="small"
                                          required
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Tooltip
                                                  title="phoneBookName"
                                                  placement="top"
                                                  arrow
                                                  sx={{ color: "#85CBF2" }}
                                                >
                                                  <InfoIcon />
                                                </Tooltip>
                                              </InputAdornment>
                                            ),
                                          }}
                                          onChange={formik.handleChange}
                                          value={formik.values.phoneBookName}
                                          error={
                                            formik.touched.phoneBookName &&
                                            Boolean(formik.errors.phoneBookName)
                                          }
                                          helperText={
                                            formik.touched.phoneBookName &&
                                            formik.errors.phoneBookName
                                          }
                                        />
                                      </div>
                                    </>
                                  )}

                                  {TableStatus.hideShow && (
                                    <>
                                      <div className="mt-0 ms-2">
                                        {/* <button type="submit">filter</button> */}
                                        <button
                                          type="submit"
                                          className={
                                            "btn btn-primary filter mb-0"
                                          }
                                          style={{
                                            fontSize: "13px",
                                            boxShadow: "none",
                                          }}
                                        >
                                          <FilterAltIcon />
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </form>
                            </div>

                            <div className="">
                              <Tooltip title="Refresh">
                                <button
                                  type="submit"
                                  className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                                  // onClick={RefreshBtn}
                                  onClick={() => RefreshBtn("Text to Copy")}
                                >
                                  {/* <i class="material-icons opacity-10">refresh</i> */}
                                  <RefreshIcon />
                                </button>
                              </Tooltip>
                            </div>
                          </div>

                          <section class="col-md-12 right_panel px-0">
                            <div class="container-fluid_ px-0">
                              <section class="" id="manage_list">
                                <div>
                                  {/* {selectedUserDetail != undefined && ( */}
                                  <div>
                                    <button
                                      ref={modelButtonReject}
                                      type="button"
                                      className="btn btn-primary d-none"
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop"
                                    >
                                      Launch static backdrop modal
                                    </button>

                                    <div
                                      className="modal fade"
                                      id="staticBackdrop"
                                      data-bs-backdrop="static"
                                      data-bs-keyboard="false"
                                      tabindex="-1"
                                      aria-labelledby="staticBackdropLabel"
                                      aria-hidden="true"
                                    >
                                      <div className="modal-dialog">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5
                                              className="modal-title"
                                              id="staticBackdropLabel"
                                            >
                                              Are you sure you want to delete?
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                            <div className="row">
                                              <div className="col-md-6">
                                                <label
                                                  for="exampleInputEmail1"
                                                  className="form-label"
                                                >
                                                  ID:
                                                </label>
                                                <input
                                                  disabled
                                                  className="form-control"
                                                  placeholder=" Id "
                                                  type="text"
                                                  minLength="3"
                                                  value={selectedUserDetail?.id}
                                                />
                                              </div>
                                              <div className="col-md-6 mt_2">
                                                <label
                                                  for="exampleInputEmail1"
                                                  className="form-label"
                                                >
                                                  PhonebookName:
                                                </label>
                                                <input
                                                  disabled
                                                  className="form-control"
                                                  placeholder=" PhonebookName "
                                                  type="text"
                                                  minLength="3"
                                                  value={
                                                    selectedUserDetail?.phonebookName
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="row mt-2">
                                              <div className="col-md-6">
                                                <label
                                                  for="exampleInputEmail1"
                                                  className="form-label"
                                                >
                                                  PhonebookDescription:
                                                </label>
                                                <input
                                                  disabled
                                                  className="form-control"
                                                  placeholder=" PhonebookDescription "
                                                  type="text"
                                                  minLength="3"
                                                  value={
                                                    selectedUserDetail?.phonebookDescription
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="modal-footer justify-content-between">
                                            <button
                                              type="button"
                                              className="btn btn-secondary w_bt"
                                              data-bs-dismiss="modal"
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-danger"
                                              data-bs-dismiss="modal"
                                              onClick={() => {
                                                rejectUserApi(
                                                  selectedUserDetail
                                                );
                                              }}
                                            >
                                              Delete
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* )} */}
                                  {/* {selectedUserDetailApprove != undefined && ( */}
                                  <div>
                                    <button
                                      ref={modelButtonApprove}
                                      type="button"
                                      className="btn btn-primary d-none"
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop1"
                                    >
                                      Launch static backdrop modal
                                    </button>

                                    <div
                                      className="modal modal_talble fade"
                                      id="staticBackdrop1"
                                      data-bs-backdrop="static"
                                      data-bs-keyboard="false"
                                      tabindex="-1"
                                      aria-labelledby="staticBackdrop1Label"
                                      aria-hidden="true"
                                    >
                                      <div className="modal-dialog ">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5
                                              className="modal-title"
                                              id="staticBackdrop1Label"
                                            >
                                              View Details
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                              // onClick={RemovePhoneBook}
                                              onClick={() => {
                                                setSelectedUserDetailApprove(
                                                  undefined
                                                );
                                                setTableStatusView({
                                                  ...TableStatusView,
                                                  hideShow: false,
                                                  pageNo: 0,
                                                });
                                              }}
                                            ></button>
                                          </div>
                                          <div
                                            className="modal-body d-flex flex-column"
                                            style={{
                                              height: "353px",
                                              overflow: "auto",
                                            }}
                                          >
                                            <div className="table-responsive">
                                              <table className="table table-striped table-bordered dataTable table-sm">
                                                <thead>
                                                  <tr role="row">
                                                    <th className="text-center width_2">
                                                      Contact Name
                                                    </th>
                                                    <th className="text-center width_2">
                                                      Mobile Number
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody
                                                  id="dropdown-item"
                                                  role="rowgroup"
                                                  className="mnu_item"
                                                >
                                                  {viewDetail?.map((arg) => {
                                                    return (
                                                      <>
                                                        <tr role="row">
                                                          <td>
                                                            {arg?.contactName}
                                                          </td>
                                                          <td>
                                                            {arg?.mobileNumber}
                                                          </td>
                                                        </tr>
                                                      </>
                                                    );
                                                  })}
                                                </tbody>
                                              </table>
                                            </div>

                                            <div className="d-flex justify-content-between mt-auto">
                                              <div>
                                                <span>
                                                  Page:
                                                  <strong>
                                                    {viewPageModal?.pageable
                                                      ?.pageNumber + 1}{" "}
                                                    of{" "}
                                                    {viewPageModal?.totalPages}
                                                  </strong>
                                                </span>
                                                {/* <span>
                                            | Go to Page :{""}
                                            <input
                                              type="number"
                                              min="0"
                                              max={totalPage}
                                              // defaultValue={pageIndex}
                                              // defaultValue={totalPageCount}
                                              value={totalPageCount}
                                              // defaultValue={pageNumber1}
                                              onChange={(e) => {
                                                const pageNumber = e.target
                                                  .value
                                                  ? Number(e.target.value)
                                                  : 0;
                                                gotoPage(pageNumber);
                                                setPageNumber1(pageNumber);
                                              }}
                                              style={{ width: "50px" }}
                                            />
                                          </span> */}
                                              </div>

                                              <div className="btn_n800">
                                                <button
                                                  className="btn btn_primary "
                                                  type="button"
                                                  style={{
                                                    background: "#2C97D4",
                                                  }}
                                                  disabled={
                                                    viewPageModal?.pageable
                                                      ?.pageNumber == 0
                                                  }
                                                  onClick={() => {
                                                    setTableStatusView({
                                                      ...TableStatusView,
                                                      pageNo:
                                                        TableStatusView.pageNo -
                                                        1,
                                                    });
                                                  }}
                                                >
                                                  Prev
                                                </button>

                                                <button
                                                  className="btn btn_primary ms-2"
                                                  type="button"
                                                  style={{
                                                    background: "#2C97D4",
                                                  }}
                                                  disabled={
                                                    viewPageModal?.totalPages ==
                                                    viewPageModal?.pageable
                                                      ?.pageNumber +
                                                      1
                                                  }
                                                  onClick={() => {
                                                    setTableStatusView({
                                                      ...TableStatusView,
                                                      pageNo:
                                                        TableStatusView.pageNo +
                                                        1,
                                                      hideShow: true,
                                                    });
                                                  }}
                                                >
                                                  Next
                                                </button>
                                                {/* <button
                onClick={() => {
                  gotoPage(pageCount - 1);
                }}
                disabled={!canNextPage}
              >
                {">>"}
              </button> */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* )} */}

                                  {/* {selectedUserEditDetails != undefined && ( */}
                                  <div>
                                    <button
                                      ref={modelButtonEdit}
                                      type="button"
                                      className="btn btn-primary d-none"
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop3"
                                    >
                                      Launch static backdrop modal
                                    </button>

                                    <div
                                      className="modal contact_list modal_input fade"
                                      id="staticBackdrop3"
                                      data-bs-backdrop="static"
                                      data-bs-keyboard="false"
                                      tabindex="-1"
                                      aria-labelledby="staticBackdrop3Label"
                                      aria-hidden="true"
                                    >
                                      <div className="modal-dialog  ">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5
                                              className="modal-title"
                                              id="staticBackdrop1Label"
                                            >
                                              Update Details
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                              onClick={() => {
                                                setRightData(null);
                                                const variable = {
                                                  phonebookName: 1,
                                                  // phonebookDescription: values.phonebookDescription,
                                                  phonebookDescription: 1,
                                                  userContactsReq: 1,
                                                };
                                                dispatch(
                                                  setRelodState(variable)
                                                );
                                              }}
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                            <div className="container-fluid">
                                              <div className="row mb-2">
                                                <div className="col-md-4">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    Id:
                                                  </label>
                                                  <input
                                                    disabled
                                                    className="form-control"
                                                    placeholder=" Id "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserEditDetails?.id
                                                    }
                                                  />
                                                </div>
                                                <div className="col-md-4">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    Phonebookname :
                                                  </label>

                                                  <input
                                                    // disabled
                                                    required
                                                    className="form-control"
                                                    placeholder="Phonebookname "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserEditDetails?.phonebookName
                                                    }
                                                    onChange={(e) => {
                                                      setSelectedUserEditDetails(
                                                        {
                                                          ...selectedUserEditDetails,
                                                          phonebookName:
                                                            e.target.value,
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="col-md-4">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    Phonebookdescription :
                                                  </label>
                                                  <input
                                                    // disabled
                                                    className="form-control"
                                                    placeholder="Phonebookdescription "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserEditDetails?.phonebookDescription
                                                    }
                                                    onChange={(e) => {
                                                      setSelectedUserEditDetails(
                                                        {
                                                          ...selectedUserEditDetails,
                                                          phonebookDescription:
                                                            e.target.value,
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                {/* <div className="col-md-4">
                                                <label
                                                  for="exampleInputEmail1"
                                                  className="form-label"
                                                >
                                                  Search :
                                                </label>
                                                <input
                                                  // disabled
                                                  className="form-control"
                                                  placeholder="Search "
                                                  type="text"
                                                  minLength="3"
                                                  onChange={handleChangesearch}
                                                />
                                              </div> */}
                                              </div>
                                            </div>

                                            <div className="row mt-5">
                                              <div className="col-md-12">
                                                {/* <div className="text-center">
                                                  <label className="m-0">
                                                    Edit Phonebook
                                                  </label>
                                                </div>
                                                <div className="d-flex justify-content-between label_transfer">
                                                  <label className="d-block">
                                                    User Contact List
                                                  </label>
                                                  <label className="d-block">
                                                    Add Contact In Phonebook{" "}
                                                  </label>
                                                </div> */}
                                                {/* <Transfer
                                                  dataSource={mockData}
                                                  // showSearch
                                                  listStyle={{
                                                    width: 270,
                                                    height: 509,
                                                  }}
                                                  operations={["Add", "Remove"]}
                                                  targetKeys={targetKeys}
                                                  onChange={handleChange9}
                                                  render={(item) =>
                                                    `${item.title}`
                                                  }
                                                  pagination
                                                /> */}
                                                <TransferListTest
                                                  onData={handleData}
                                                  width={380}
                                                  height={300}
                                                  rightData={rightData}
                                                  pageType="EditPage"
                                                />
                                              </div>
                                            </div>
                                          </div>

                                          <div className="modal-footer justify-content-between">
                                            <button
                                              type="button"
                                              className="btn btn-secondary shadow"
                                              data-bs-dismiss="modal"
                                              onClick={() => {
                                                setRightData(null);
                                                const variable = {
                                                  phonebookName: 1,
                                                  // phonebookDescription: values.phonebookDescription,
                                                  phonebookDescription: 1,
                                                  userContactsReq: 1,
                                                };
                                                dispatch(
                                                  setRelodState(variable)
                                                );
                                              }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary editcolor shadow okbtn"
                                              data-bs-dismiss="modal"
                                              onClick={() => {
                                                UpdateUserApi(
                                                  selectedUserEditDetails
                                                );
                                              }}
                                            >
                                              Update{" "}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* )} */}
                                  {/* {downloadModelOpen != undefined && ( */}

                                  <div>
                                    <button
                                      // ref={modelButtonApprove}
                                      ref={modelButtonDownload}
                                      type="button"
                                      className="btn btn-primary d-none"
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop2"
                                    >
                                      Launch static backdrop modal
                                    </button>

                                    <div
                                      className="modal fade"
                                      id="staticBackdrop2"
                                      data-bs-backdrop="static"
                                      data-bs-keyboard="false"
                                      tabindex="-1"
                                      aria-labelledby="staticBackdrop2Label"
                                      aria-hidden="true"
                                    >
                                      <div className="modal-dialog ">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5
                                              className="modal-title"
                                              id="staticBackdrop2Label"
                                            >
                                              Download Request
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                            ></button>
                                          </div>

                                          <div className="modal-body">
                                            Are you sure you want to initiate
                                            the download request ?
                                          </div>

                                          <div className="modal-footer justify-content-between">
                                            <button
                                              type="button"
                                              className="btn btn-secondary shadow"
                                              data-bs-dismiss="modal"
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary editcolor shadow okbtn"
                                              data-bs-dismiss="modal"
                                              onClick={DownloadButtonApi}
                                            >
                                              Download Request
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* )} */}

                                  <div className="container-fluid">
                                    <div class="card-body mt-0 pt-0 px-0 table_overFlow">
                                      <div>
                                        {selectedFlatRows.length > 0 && (
                                          <button onClick={deletUser}>
                                            Delete Users
                                          </button>
                                        )}

                                        {/* {/ <button onClick={changeOrder}>Change Order</button> /} */}
                                      </div>
                                      <div className="">
                                        <table
                                          {...getTableProps()}
                                          id="example"
                                          className="table table-striped table-bordered dataTable table-sm"
                                          style={{ width: "100%" }}
                                        >
                                          <thead>
                                            {headerGroups.map((headerGroup) => (
                                              <tr
                                                {...headerGroup.getHeaderGroupProps()}
                                              >
                                                {headerGroup.headers.map(
                                                  (column) => (
                                                    <th
                                                      {...column.getHeaderProps(
                                                        column.getSortByToggleProps()
                                                      )}
                                                      className="text-center width_2"
                                                    >
                                                      {column.render("Header")}
                                                      <span>
                                                        {column.isSorted
                                                          ? column.isSortedDesc
                                                            ? "↑"
                                                            : "↓"
                                                          : ""}
                                                      </span>
                                                    </th>
                                                  )
                                                )}
                                              </tr>
                                            ))}
                                          </thead>
                                          <tbody
                                            id="dropdown-item"
                                            {...getTableBodyProps()}
                                          >
                                            {page.map((row) => {
                                              prepareRow(row);
                                              return (
                                                <tr {...row.getRowProps()}>
                                                  {row.cells.map((cell) => {
                                                    return (
                                                      <td
                                                        {...cell.getCellProps()}
                                                        // className="text-center"
                                                        className={
                                                          cell.column.Header ==
                                                            "Contact Count" ||
                                                          cell.column.Header ==
                                                            "Id"
                                                            ? "text-end"
                                                            : cell.column
                                                                .Header ==
                                                                "Action" ||
                                                              cell.column
                                                                .Header ==
                                                                "Download" ||
                                                              cell.column
                                                                .Header ==
                                                                "Download Request"
                                                            ? "text-center"
                                                            : "text-start"
                                                        }
                                                      >
                                                        {cell.render("Cell")}
                                                      </td>
                                                    );
                                                  })}
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <span>
                                            Page:
                                            <strong>
                                              {data2?.pageable?.pageNumber + 1}{" "}
                                              of {data2?.totalPages}
                                            </strong>
                                          </span>
                                          {/* <span>
                                            | Go to Page :{""}
                                            <input
                                              type="number"
                                              min="0"
                                              max={totalPage}
                                              // defaultValue={pageIndex}
                                              // defaultValue={totalPageCount}
                                              value={totalPageCount}
                                              // defaultValue={pageNumber1}
                                              onChange={(e) => {
                                                const pageNumber = e.target
                                                  .value
                                                  ? Number(e.target.value)
                                                  : 0;
                                                gotoPage(pageNumber);
                                                setPageNumber1(pageNumber);
                                              }}
                                              style={{ width: "50px" }}
                                            />
                                          </span> */}
                                        </div>

                                        <div className="btn_n800">
                                          <button
                                            className="btn btn_primary "
                                            type="button"
                                            style={{ background: "#2C97D4" }}
                                            disabled={
                                              data2?.pageable?.pageNumber == 0
                                            }
                                            onClick={() => {
                                              setTableStatus({
                                                ...TableStatus,
                                                pageNo: TableStatus.pageNo - 1,
                                              });
                                            }}
                                          >
                                            Prev
                                          </button>

                                          <button
                                            className="btn btn_primary ms-2"
                                            type="button"
                                            style={{ background: "#2C97D4" }}
                                            disabled={
                                              data2?.totalPages ==
                                              data2?.pageable?.pageNumber + 1
                                            }
                                            onClick={() => {
                                              setTableStatus({
                                                ...TableStatus,
                                                pageNo: TableStatus.pageNo + 1,
                                              });
                                            }}
                                          >
                                            Next
                                          </button>
                                          {/* <button
                onClick={() => {
                  gotoPage(pageCount - 1);
                }}
                disabled={!canNextPage}
              >
                {">>"}
              </button> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                              <section class="modal_1">
                                {/* <!-- Button trigger modal --> */}
                                {/* <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Launch demo modal
        </button> --> */}

                                {/* <!-- Modal --> */}
                                <div
                                  class="modal fade"
                                  id="exampleModal6"
                                  tabindex="-1"
                                  aria-labelledby="exampleModalLabel"
                                  aria-hidden="true"
                                >
                                  <div class="modal-dialog">
                                    <div class="modal-content">
                                      <div class="modal-header">
                                        <h5
                                          class="modal-title"
                                          id="exampleModalLabel"
                                        >
                                          Modal title
                                        </h5>
                                        <button
                                          type="button"
                                          class="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                        ></button>
                                      </div>
                                      <div class="modal-body">
                                        <form class="m-0">
                                          <div class="">
                                            <div class="row align-items-center">
                                              <div class="col-4">
                                                <label
                                                  for="exampleInputEmail1"
                                                  class="form-label m-0"
                                                >
                                                  number list name:
                                                </label>
                                              </div>
                                              <div class="col-8">
                                                <input
                                                  type="text"
                                                  class="form-control"
                                                  id="exampleInputEmail1"
                                                  aria-describedby="emailHelp"
                                                />
                                              </div>
                                            </div>
                                            <div class="row mt-2">
                                              <div class="col-4">
                                                <label
                                                  for="exampleInputTextarea"
                                                  class="form-label m-0"
                                                >
                                                  description:
                                                </label>
                                              </div>
                                              <div class="col-8">
                                                <textarea
                                                  class="form-control"
                                                  placeholder="Leave a comment here"
                                                  id="exampleInputTextarea"
                                                ></textarea>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="bxg_8 mt-3">
                                            <div class="flt_start">
                                              <div class="float-start d-flex align-items-center flex-wrap">
                                                {/* <!-- <div class=""> --> */}
                                                <div class="form-check">
                                                  <div class="">
                                                    <input
                                                      class="form-check-input"
                                                      type="radio"
                                                      name="flexRadioDefault"
                                                      id="flexRadioDefault1"
                                                      onclick="radio_1()"
                                                    />
                                                  </div>
                                                  <label
                                                    class="form-check-label"
                                                    for="flexRadioDefault1"
                                                  >
                                                    from file
                                                  </label>
                                                </div>
                                                <div class="form-check ms-2">
                                                  <div class="">
                                                    <input
                                                      class="form-check-input"
                                                      type="radio"
                                                      name="flexRadioDefault"
                                                      id="flexRadioDefault2"
                                                      onclick="radio_2()"
                                                      checked=""
                                                    />
                                                  </div>
                                                  <label
                                                    class="form-check-label"
                                                    for="flexRadioDefault2"
                                                  >
                                                    direct input
                                                  </label>
                                                </div>
                                                {/* <!-- </div> --> */}
                                              </div>
                                            </div>
                                            <div class="row align-items-center my-2">
                                              <div class="col-4">
                                                <label
                                                  for="exampleInputEmail1"
                                                  class="form-label m-0"
                                                >
                                                  upload from csv/txt/xls/xlsx
                                                </label>
                                              </div>
                                              <div class="col-8">
                                                <input
                                                  type="file"
                                                  class="form-control"
                                                  id="exampleInputEmail1"
                                                  aria-describedby="emailHelp"
                                                />
                                              </div>
                                            </div>
                                            <p>
                                              <b class="text-capitalize">
                                                note:
                                              </b>{" "}
                                              jdksvc ewbhvber webvweb vfvvwer
                                              fvewrre vferwver vfervgrv dfverv
                                              vfrev vferver vfrerre vferver
                                              vrrervr
                                            </p>
                                          </div>
                                          <button
                                            type="button"
                                            class="btn btn-primary d-flex align-items-center text-capitalize m-0 ms-auto mt-4"
                                          >
                                            <i class="fas fa-save d-block"></i>
                                            <span class="d-block ms-1">
                                              upload & save
                                            </span>
                                          </button>
                                        </form>
                                      </div>
                                      <div class="modal-footer">
                                        <button
                                          type="button"
                                          class="btn btn-secondary"
                                          data-bs-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                        <button
                                          type="button"
                                          class="btn btn-primary"
                                        >
                                          Save changes
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            </div>
                          </section>
                        </div>
                      </>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="text-center mt-4">
              {data?.length == 0 && open ? null : (
                <h5 className="text-center mt-4">No Record Found..!!</h5>
              )}
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default PhoneBookList;
